
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3848_20266)"}},[_c('path',{attrs:{"d":"M.894 7.316L22.284.063c1.01-.321 1.974.643 1.653 1.652l-7.253 21.391c-.32 1.01-1.698 1.194-2.295.276L9.8 16.358l8.033-9.869c.23-.275-.046-.55-.321-.321l-9.915 8.079-7.023-4.59c-.873-.643-.735-1.974.32-2.341z","fill":"#262626"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3848_20266"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    